import React from 'react';

import GAException from 'src/components/GAException';
import { useSelector } from 'react-redux';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import AuthRouteRegisterOrFromMiCabal from './AuthRouteRegisterOrFromMiCabal';
import { toCreditCardData } from 'src/services/creditCardService';

function AuthRouteTCRegisterDIMO({ children }) {
  const account = useSelector((state) => state.account);
  const history = useHistory();
  const location = useLocation();

  // El estado de la ruta se pide al router, no se camina el arbol de hijos.
  // Antes se leia children.props.children.props.location.state, que dependia
  // de cuantas capas hubiera entre el Guard y el Component: al envolver las
  // rutas con ErrorBoundary el nivel se corrio, el acceso tiraba TypeError,
  // el catch lo devolvia como null y las 12 rutas /app/creditcard/*
  // redirigian a /app como si no hubiera tarjeta.
  const propsState = location?.state || null;

  if (!account.user) {
    return <Redirect to="/login" />;
  }

  if (!account.user.flagUserActivate && !account.user.flagUsuarioMiCabal) {
    return AuthRouteRegisterOrFromMiCabal({children: children});
  }

  if (!propsState || !propsState.creditCard) {
    return <Redirect to="/app" />;
  }

  const creditCardData = toCreditCardData(propsState.creditCard);

  // Ult. validacion de que si existan una tarjeta cargada
  if (!(creditCardData.NUMERO_TARJETA.length > 1)) {
    return <Redirect to="/app" />;
  }
  else {
    // Validamos si la tarjeta en cuestion esta vinculada a DIMO
    if (creditCardData.VINCULADA_DIMO !== 'S') {
      history.replace({ pathname: "/app" })
      history.push({
        pathname: "/app/creditcard/vincularDimoTC",
        state: {
          creditCard: creditCardData,
        }
      });
    }
  }

  // Si llegamos hasta aqui, continuamos normalmente...
  return children;
}

AuthRouteTCRegisterDIMO.propTypes = {
  children: PropTypes.any
};

export default AuthRouteTCRegisterDIMO;
